import React from 'react';
import { Handle, Position } from '@xyflow/react';

const LinkNode = (props) => {
  const { data, isConnectable, id, type, ...rest } = props;
  const style = data.style || {};
  const width = style.width || 120;
  const height = style.height || 60;
  const zIndex = typeof style.zIndex === 'number' ? style.zIndex : 10;

  const nodeType = data.linkItemType || 'custom';
  const badgeColor = data.customBadgeColor || (
    localStorage.getItem('cfg_badgeColor_' + nodeType) || {
      conversation: '#007bff',
      agent: '#28a745',
      commit: '#ffc107',
      collection: '#6f42c1',
      custom: '#6c757d'
    }[nodeType] || '#6c757d'
  );

  const handleDiameter = Number(localStorage.getItem('cfg_handleDiameter')) || 18;
  const handleColor = localStorage.getItem('cfg_handleColor') || '#222222';
  const handleBorderColor = localStorage.getItem('cfg_handleBorderColor') || '#fff';

  // Compose the full node object to pass to onEdit/onView
  const nodeObj = { id, data, type, ...rest };

  const handleViewClick = (e) => {
    e.stopPropagation();
    if (!data.link) return;
    switch (data.viewMode) {
      case 'modal':
      case 'iframe':
        data.onView && data.onView(nodeObj);
        break;
      case 'tab':
      default:
        let link = data.link;
        if (!/^https?:\/\//i.test(link)) {
          if (!link.startsWith('/')) link = '/' + link;
          link = window.location.origin + link;
        }
        window.open(link, '_blank');
        break;
    }
  };

  var handleStyle = {
    width: handleDiameter,
    height: handleDiameter,
    minWidth: handleDiameter,
    minHeight: handleDiameter,
    maxWidth: handleDiameter,
    maxHeight: handleDiameter,
    background: handleColor,
    background: badgeColor,
    // border: `2px solid ${handleBorderColor}`,
    // boxShadow: '0 1px 2px #0002',
    zIndex: 1
  }

  return (
    <div
      className="custom-node position-relative"
      style={{
        width,
        height,
        zIndex,
        position: 'relative',
        padding: '0px 5px 0px 5px',
        border: `1px solid ${data.color || '#ddd'}`,
        borderRadius: '7px',
        background: data.fill || 'white',
        minWidth: 110,
        minHeight: 50,
        overflow: 'visible',
        cursor: 'default',
        fontSize: '9.5px',
        color: '#222',
        boxShadow: data.color ? `0 0 0 2px ${data.color}33` : undefined,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      title={data.link ? `View in ${data.viewMode || 'tab'}` : ''}
      onClick={data.onEdit ? (e) => { e.stopPropagation(); data.onEdit(nodeObj); } : undefined}
    >

      <div className="custom-k3-node__handles custom-k3-node__handles-top">
        <Handle
          type="target"
          id="top-1"
          position={Position.Top}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-top"
          style={handleStyle}
        />
        <Handle
          type="target"
          id="top-2"
          position={Position.Top}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-top"
          style={handleStyle}
        />

        <Handle
          type="target"
          id="top-3"
          position={Position.Top}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-top"
          style={handleStyle}
        />
      </div>

      <div className="custom-k3-node__handles custom-k3-node__handles-bottom">
        <Handle
          type="source"
          id="bottom-1"
          position={Position.Bottom}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-bottom"
          style={handleStyle}
        />
        <Handle
          type="source"
          id="bottom-2"
          position={Position.Bottom}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-bottom"
          style={handleStyle}
        />

        <Handle
          type="source"
          id="bottom-3"
          position={Position.Bottom}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-bottom"
          style={handleStyle}
        />
      </div>

      <div className="custom-k3-node__handles custom-k3-node__handles-left">
        <Handle
          type="target"
          id="left-1"
          position={Position.Left}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-left"
          style={handleStyle}
        />
        <Handle
          type="target"
          id="left-2"
          position={Position.Left}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-left"
          style={handleStyle}
        />

        <Handle
          type="target"
          id="left-3"
          position={Position.Left}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-left"
          style={handleStyle}
        />
      </div>

      <div className="custom-k3-node__handles custom-k3-node__handles-right">
        <Handle
          type="source"
          id="right-1"
          position={Position.Right}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-right"
          style={handleStyle}
        />
        <Handle
          type="source"
          id="right-2"
          position={Position.Right}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-right"
          style={handleStyle}
        />

        <Handle
          type="source"
          id="right-3"
          position={Position.Right}
          isConnectable={isConnectable}
          className="custom-k3-node__handle custom-k3-node__handle-right"
          style={handleStyle}
        />
      </div>


      <div style={{
        width: '100%',
        textAlign: 'center',
        fontWeight: 500,
        fontSize: '10px',
        marginBottom: 2,
        wordBreak: 'break-word',
        lineHeight: 1.2,
        minHeight: 15,
        color: data.textColor || '#222',
      }}>
        {data.emoji && (
          <span style={{ fontSize: 18, marginRight: 4, verticalAlign: 'middle' }}>{data.emoji}</span>
        )}
        {data.label}
      </div>
      {nodeType && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          marginTop: 2
        }}>
          <span
            style={{
              background: badgeColor,
              color: 'white',
              borderRadius: 6,
              fontSize: 9,
              padding: '1.5px 6px',
              fontWeight: 600,
              letterSpacing: 0.2,
              margin: '0 auto',
              minWidth: 36,
              textAlign: 'center',
              boxShadow: '0 1px 2px #0001',
              cursor: data.link ? 'pointer' : 'default',
            }}
            title={data.link ? `View in ${data.viewMode || 'tab'}` : ''}
            onClick={data.link ? handleViewClick : undefined}
          >
            {nodeType}
          </span>
        </div>
      )}
    </div>
  );
};

export default LinkNode; 